
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18 0c3.3 0 5.999 2.7 5.999 6L24 18c0 3.3-2.7 6-6 6H6c-3.3 0-6-2.7-6-6V6c0-3.3 2.7-6 6-6h12zm4.909 18l-.001-12c0-2.7-2.21-4.91-4.91-4.91H6C3.3 1.09 1.09 3.3 1.09 6v12c0 2.7 2.21 4.91 4.91 4.91h12c2.7 0 4.909-2.21 4.909-4.91zM12 5.819c3.4 0 6.182 2.782 6.182 6.182 0 3.4-2.782 6.182-6.182 6.182-3.4 0-6.182-2.782-6.182-6.182C5.818 8.6 8.6 5.818 12 5.818zm0 11.24c2.782 0 5.058-2.276 5.058-5.058S14.782 6.942 12 6.942 6.942 9.218 6.942 12 9.218 17.058 12 17.058zm7.273-14.149c1.013 0 1.818.805 1.818 1.818a1.807 1.807 0 01-1.818 1.818 1.807 1.807 0 01-1.818-1.818c0-1.013.805-1.818 1.818-1.818zm0 2.597c.442 0 .779-.338.779-.779a.766.766 0 00-.78-.779.766.766 0 00-.778.78c0 .44.338.778.779.778z"}})])
          )
        }
      }
    